// Validação e conversão do fluxo de SUBSTITUIR certificado (§6.2):
// header PEM validado no front ANTES do submit (feedback imediato;
// o backend revalida com X509 real) e conversão PEM texto → BASE64
// (contrato do PUT /certificate). Puro p/ teste unitário direto.
import { z } from "zod"

import type { CertificateUploadPayload } from "@/types/admin-processor-config"

// Headers PEM aceitos (o backend faz o parse X509 de verdade).
export const PEM_CERTIFICATE_HEADER =
  /-----BEGIN CERTIFICATE-----/
export const PEM_PRIVATE_KEY_HEADER =
  /-----BEGIN (RSA |EC |ENCRYPTED )?PRIVATE KEY-----/

// Form do "Colar PEM": certificado obrigatório com header válido;
// chave privada OPCIONAL (ausente = mantém a atual), mas se colada
// precisa de header de chave.
export const buildReplaceCertificateSchema = (messages: {
  certificateRequired: string
  invalidCertificateHeader: string
  invalidKeyHeader: string
}) =>
  z.object({
    certificatePem: z
      .string()
      .trim()
      .min(1, messages.certificateRequired)
      .refine(
        (value) => PEM_CERTIFICATE_HEADER.test(value),
        messages.invalidCertificateHeader
      ),
    privateKeyPem: z
      .string()
      .trim()
      .refine(
        (value) =>
          value === "" ||
          PEM_PRIVATE_KEY_HEADER.test(value),
        messages.invalidKeyHeader
      ),
  })

export type ReplaceCertificateValues = z.infer<
  ReturnType<typeof buildReplaceCertificateSchema>
>

// PEM (ASCII) → base64 do contrato.
export const encodePemToBase64 = (pem: string): string =>
  globalThis.btoa(pem)

// Form → payload do PUT: base64; chave vazia FICA FORA (mantém).
export const toCertificateUploadPayload = (
  values: ReplaceCertificateValues
): CertificateUploadPayload => ({
  certificatePem: encodePemToBase64(
    values.certificatePem.trim()
  ),
  ...(values.privateKeyPem.trim()
    ? {
        privateKeyPem: encodePemToBase64(
          values.privateKeyPem.trim()
        ),
      }
    : {}),
})
